import { render, staticRenderFns } from "./RadioScaleInput.vue?vue&type=template&id=eddea19a&scoped=true&"
import script from "./RadioScaleInput.vue?vue&type=script&lang=js&"
export * from "./RadioScaleInput.vue?vue&type=script&lang=js&"
import style0 from "./RadioScaleInput.vue?vue&type=style&index=0&id=eddea19a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddea19a",
  null
  
)

export default component.exports